var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.426,
    height: 17.873,
    viewBox: "0 0 28.426 17.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c9ffc9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(395.617 -262.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-395.617 262.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-381.419,279.947a15.165,15.165,0,0,1-7.012-2.211,25.819,25.819,0,0,1-6.852-6.02.989.989,0,0,1-.088-1.389,23.055,23.055,0,0,1,9.851-7.505,12.023,12.023,0,0,1,9.645.58,24.456,24.456,0,0,1,8.4,6.875.936.936,0,0,1,.05,1.294c-2.931,3.563-6.307,6.524-10.859,7.821A29.833,29.833,0,0,1-381.419,279.947Zm-12.055-9a22.874,22.874,0,0,0,7.492,5.935,10.429,10.429,0,0,0,9.308-.071,22.142,22.142,0,0,0,6.708-5.168c.2-.214.384-.437.609-.694-2.7-2.987-5.6-5.6-9.572-6.611a9.767,9.767,0,0,0-3.565-.257C-387.159,264.675-390.4,267.625-393.474,270.945Z",
    transform: "translate(395.617 -262.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-307.334,309.672a4.268,4.268,0,0,1-4.263-4.243,4.267,4.267,0,0,1,4.288-4.278,4.267,4.267,0,0,1,4.234,4.272A4.267,4.267,0,0,1-307.334,309.672Zm.022-6.627a2.37,2.37,0,0,0-2.391,2.341,2.37,2.37,0,0,0,2.341,2.391,2.37,2.37,0,0,0,2.391-2.341A2.369,2.369,0,0,0-307.312,303.045Z",
    transform: "translate(321.546 -296.524)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.6e6cc3b17c203ab8fcb019926f7be1f6.svg";
export { ForwardRef as ReactComponent };